/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yourchangeshavebeensavedsuccessfully5Inputs */

const en_yourchangeshavebeensavedsuccessfully5 = /** @type {(inputs: Yourchangeshavebeensavedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your changes have been saved successfully.`)
};

const de_yourchangeshavebeensavedsuccessfully5 = /** @type {(inputs: Yourchangeshavebeensavedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert.`)
};

/**
* | output |
* | --- |
* | "Your changes have been saved successfully." |
*
* @param {Yourchangeshavebeensavedsuccessfully5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const yourchangeshavebeensavedsuccessfully5 = /** @type {((inputs?: Yourchangeshavebeensavedsuccessfully5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yourchangeshavebeensavedsuccessfully5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yourchangeshavebeensavedsuccessfully5(inputs)
	return de_yourchangeshavebeensavedsuccessfully5(inputs)
});
export { yourchangeshavebeensavedsuccessfully5 as "yourChangesHaveBeenSavedSuccessfully" }